import { GoalPaceStatus, SavingsGoalProgress } from "../../../services";
import { GoalStatusDisplay, GoalTone } from "./types";

const PACE_LABEL: Record<GoalPaceStatus, string> = {
  AHEAD: "Ahead",
  ON_TRACK: "On track",
  BEHIND: "Behind",
};

// On track reads as info, not amber: being on pace is a good state.
const PACE_TONE: Record<GoalPaceStatus, GoalTone> = {
  AHEAD: "success",
  ON_TRACK: "info",
  BEHIND: "error",
};

export const PACE_BAR_COLOR: Record<GoalPaceStatus, string> = {
  AHEAD: "var(--color-status-success)",
  ON_TRACK: "var(--color-status-info)",
  BEHIND: "var(--color-status-error)",
};

export const REACHED_BAR_COLOR = "var(--color-status-success)";

export const savingsGoalStatusOf = (
  progress: SavingsGoalProgress,
): GoalStatusDisplay => {
  // A goal reached before its deadline stays active until the deadline closes it.
  if (progress.lifecycleStatus === "COMPLETED") {
    return {
      label: "Target reached",
      tone: "success",
      barColor: REACHED_BAR_COLOR,
    };
  }
  const pace = progress.paceStatus;
  return {
    label: PACE_LABEL[pace],
    tone: PACE_TONE[pace],
    barColor: PACE_BAR_COLOR[pace],
  };
};
